import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Heart = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M12.461 17.63a3.26 3.26 0 0 1-4.919 0c-1.268-1.42-3.081-3.523-3.932-4.879l-.001-.001C2.297 10.654 1.25 8.657 1.25 6.524c0-2.357 1.619-5.274 5.023-5.274 1.492 0 2.82.7 3.728 1.8.906-1.097 2.234-1.8 3.726-1.8 3.404 0 5.023 2.913 5.023 5.274 0 2.133-1.047 4.13-2.359 6.226-1.103 1.762-2.55 3.334-3.93 4.88" }) }));
});
Heart.displayName = 'Heart';
Heart.__iconComponentType = 'standard';
export default Heart;
//# sourceMappingURL=Heart.js.map